'use client'

import { useMemo, useState } from 'react'
import { getRewardItemPrice } from '@/utils/util'
import { isVariantInStock, rewardOptionProduct } from '../variantOptions'
import { useCart } from './useCart'

export function useRewardVariantPicker() {
  const { pendingReward, closeRewardPicker, dismissRewardPicker, addRewardItem } = useCart()
  const [shown, setShown] = useState(pendingReward)
  if (pendingReward && pendingReward !== shown) setShown(pendingReward)

  const reward = shown?.item ?? null
  const optionProduct = useMemo(() => reward ? rewardOptionProduct(reward) : null, [reward])

  const add = (variantId: string) => {
    if (!shown) return
    closeRewardPicker()
    addRewardItem(shown.item, shown.type, variantId)
  }

  return {
    isOpen: !!pendingReward,
    close: dismissRewardPicker,
    reward,
    variants: (reward?.variants || []) as any[],
    optionProduct,
    add,
    getPrice: (variant: any) => reward && variant ? getRewardItemPrice({ ...reward, variant }) : 0,
    isAvailable: (variant: any) => isVariantInStock(reward, variant),
  }
}
